module.exports = __webpack_public_path__ + "img/Current_Consumption.d2acfa30.jpeg";